import { OnlineContainersEditFilterController } from "./filter.controller";

angular
    .module("thor.online-containers.edit.filter.component", [])
    .component("thorOnlineContainersEditFilter", {
        bindings: {
            isPast: "<",
            itemsStatesCount: "<",
            filterParams: "=",
            filterQueryOptions: "=",
            reset: "&"
        },
        controller: OnlineContainersEditFilterController,
        template: require("./filter.html")
    });
